import React from 'react';

import { dateFNS, fromTimeZoneToUTC, toISOString } from '@gogame/intl-ts';

import { GetIOEntityName, IsAmendment } from 'scenes/IO/helpers';

import { useLoadIo, useCreateIo, useUpdateIo } from '../../data';
import IOForm from './IOForm';
import { PRE_SET } from './Agreement';
import {
  PERIOD,
  AGREEMENT,
  AGREEMENT_TYPE,
  PAYMENT_TERMS,
  PAYMENT_TERMS_ID,
  BUDGET,
  RATE_OF_NET,
  PERMISSIONS,
  GO_GAME_ACCESS_PARAGRAPH_EXCLUDED,
  GO_GAME_ACCESS_PARAGRAPH,
  BUSINESS_PARTNER,
  BUSINESS_PARTNER_VERSION,
  SIGNED_BY_PUBLISHER,
} from './constants';

const NEXT_4_MONTHS = toISOString(
  fromTimeZoneToUTC([
    dateFNS.startOfMonth(dateFNS.addMonths(new Date(), 1)),
    dateFNS.endOfMonth(dateFNS.addMonths(new Date(), 4)),
  ])
);

export const IOFormCreate = ({
  onSubmit: _,
  businessPartner,
  businessPartnerVersion,
  onClose,
  ...props
}) => {
  const [createIo, { isLoading: isCreating }] = useCreateIo();

  const handleSubmit = async (values, _imperativeMethods, meta) => {
    let id = await createIo({
      ...values,
      ...meta,
    });
    onClose({ id });
  };

  return (
    <IOForm
      title={'Add IO'}
      {...props}
      initialValues={{
        [BUSINESS_PARTNER]: businessPartner,
        [BUSINESS_PARTNER_VERSION]: businessPartnerVersion,
        [AGREEMENT]: {
          [AGREEMENT_TYPE]: 0,
        },
        [PAYMENT_TERMS]: {
          [PAYMENT_TERMS_ID]: 1,
        },
        [PERIOD]: NEXT_4_MONTHS,
        [BUDGET]: {
          [RATE_OF_NET]: 0,
        },
        [GO_GAME_ACCESS_PARAGRAPH]: GO_GAME_ACCESS_PARAGRAPH_EXCLUDED,
        actions: ['SendForApproval'],
      }}
      actions={PERMISSIONS.all}
      loading={isCreating}
      onSubmit={handleSubmit}
      onClose={onClose}
    />
  );
};

export const AmendmentFormCreate = ({
  id,
  onClose,
  onExited,
  open,
  ...props
}) => {
  const { data, isLoading, isRefetching } = useLoadIo(id);
  const [createIo, { isLoading: isCreating }] = useCreateIo();

  const handleSubmit = async (values, _imperativeMethods, meta) => {
    let iOid = await createIo({
      ...values,
      ...meta,
      parentIo: id,
    });
    onClose({ iOid });
  };

  return (
    <IOForm
      title={'Add Amendment'}
      {...props}
      amendment={true}
      initialValues={data}
      actions={PERMISSIONS.amendment}
      loading={isLoading || isCreating}
      fetchinf={isRefetching}
      enableReinitialize={true}
      onSubmit={handleSubmit}
      onClose={onClose}
      onExited={onExited}
      open={open}
    />
  );
};

export const IoFormEdit = ({
  id,
  onSubmit,
  onClose,
  onExited,
  open,
  ...props
}) => {
  const { data, isLoading, isRefetching } = useLoadIo(id);
  const [updateIo, { isLoading: isUpdating }] = useUpdateIo();

  const title = GetIOEntityName(data);
  const amendment = IsAmendment(data);

  const handleSubmit = async (values, _imperativeMethods, meta) => {
    let response = await updateIo({
      ...values,
      ...meta,
    });
    onClose(response);
  };

  return (
    <IOForm
      {...props}
      title={`Edit ${title}`}
      entityId={id}
      initialValues={
        data?.[AGREEMENT]?.[AGREEMENT_TYPE] === PRE_SET
          ? {
              ...data,
              [SIGNED_BY_PUBLISHER]: true,
            }
          : data
      }
      loading={isLoading || isRefetching || isUpdating}
      active={!!data}
      actions={amendment ? PERMISSIONS.amendment : PERMISSIONS.all}
      amendment={amendment}
      enableReinitialize={true}
      onSubmit={handleSubmit}
      onClose={onClose}
      onExited={onExited}
      open={open}
    />
  );
};
